import * as yup from 'yup'
import { CompanyDto } from './companyDto'
import { InboundTripPAPSDto } from './inboundTripPAPSDto'
import { InboundTripDriverInformationDto } from './inboundTripDriverInformationDto'
import { InboundTripImportBranchDto } from './inboundTripImportBranchDto'
import moment from 'moment'

export class InboundTripDto {
  inboundTripGuid?: string = undefined
  inboundTripNumber?: string = undefined
  inboundTransporterCompany?: CompanyDto = undefined
  inboundTransporterCompanySCAC?: string = undefined
  inboundTransporterCompanyEmail?: string = undefined
  entryNumber?: string = undefined
  // 25939 R05 P1
  // 1. Update the “Add Inbound Trip” dialog to auto-populate the Entry Date field with the current date.
  // Maxwell Sommer 12/17/2025
  entryDate?: string = moment().format('yyyy-MM-DD') // Format: yyyy-mm-dd
  portOfEntryCityState?: string = undefined
  portOfEntryPortCode?: string = undefined
  isLocked: boolean = false
  inboundTripPAPS: InboundTripPAPSDto[] = []
  driverInformation?: InboundTripDriverInformationDto = undefined
  importBranch?: InboundTripImportBranchDto = undefined
  sentToBrokerDate?: string = undefined
}

export const inboundTripValidationSchema = yup.object<InboundTripDto>({
  inboundTripNumber: yup.string().max(200, 'Inbound Trip # cannot be more than 200 characters.').required('Inbound Trip # is required.'),
  inboundTransporterCompany: yup.object().required('Inbound Transporter Company is required.'),
  inboundTransporterCompanyEmail: yup
    .string()
    .email('Inbound Transporter Company Email must be a valid email.')
    .max(320, 'Inbound Transporter Company Email cannot be more than 320 characters.')
    .nullable(),
  entryNumber: yup.string().max(200, 'Entry # cannot be more than 200 characters.').nullable(),
  entryDate: yup.date().nullable()
})
